export function formatCount(count = 0, locale) {
    return !Number.isNaN(count * 1) ? new Intl.NumberFormat(locale).format(count * 1) : String(count);
}
